// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"yo-z","breadcrumbForward":"zo-z","breadcrumbBack":"Ao-z","selected":"Bo-z"};